import { useState } from 'react';
import { IOperacao } from '../../../../interfaces/IOperacaoPLG';
import TitularArrendatarioListaProcessos from './titularArrendatarioListaProcessos/titularArrendatarioListaProcessos';
import TitularArrendatarioNovaOperacaoPLG from './titularArrendatarioNovaOperacao/titularArrendatarioNovaOperacao';
import TitularArrendatarioOutrosRegimes from './titularArrendatarioOutrosRegimes/titularArrendatarioOutrosRegimes';
import { IEstadoTitularArrendatario } from '../../lib/titularArrendatarioEstadoProcesso';

interface ITitularArrendatarioNovaAquisicaoProps {
  isNovaOperacaoPLG: boolean;
  setNovaOperacaoPLG: React.Dispatch<React.SetStateAction<boolean>>;
  isEdicaoOutrosRegimes: boolean;
  setIsEdicaoOutrosRegimes: React.Dispatch<React.SetStateAction<boolean>>;
  estadoTela: IEstadoTitularArrendatario | null;
  setEstadoTela: React.Dispatch<React.SetStateAction<IEstadoTitularArrendatario | null>>;
}

function TitularArrendatarioProcessoMinerario({
  isNovaOperacaoPLG,
  setNovaOperacaoPLG,
  isEdicaoOutrosRegimes,
  setIsEdicaoOutrosRegimes,
  estadoTela,
  setEstadoTela,
}: Readonly<ITitularArrendatarioNovaAquisicaoProps>) {
  const [edicaoOperacao, setEdicaoOperacao] = useState<IOperacao>();

  const content = () => {
    if (isNovaOperacaoPLG) {
      return (
        <TitularArrendatarioNovaOperacaoPLG
          setNovaOperacaoPLG={setNovaOperacaoPLG}
          edicaoOperacao={edicaoOperacao}
          setEdicaoOperacao={setEdicaoOperacao}
          salvarRascunho={() => {}}
        />
      );
    }
    if (isEdicaoOutrosRegimes) {
      return <TitularArrendatarioOutrosRegimes setIsEdicaoOutrosRegimes={setIsEdicaoOutrosRegimes} />;
    } else {
      return (
        <TitularArrendatarioListaProcessos
          setNovaOperacaoPLG={setNovaOperacaoPLG}
          setEdicaoOperacao={setEdicaoOperacao}
          setIsEdicaoOutrosRegimes={setIsEdicaoOutrosRegimes}
          estadoTela={estadoTela}
          setEstadoTela={setEstadoTela}
        />
      );
    }
  };

  return <>{content()}</>;
}

export default TitularArrendatarioProcessoMinerario;
